export default __webpack_public_path__ + "static/media/litho-demo-marketing-agency.24ccd0e2.jpg";